module.exports = __webpack_public_path__ + "static/media/bannerImageMenu.3b3f794b.jpg";